import React, { useCallback, useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'
import Resx from '@/components/Resx'
import { Main, MainBody, MainTop, MainTopLeft, MainTopTitle, WhiteBox } from '@/components/Layout'
import context from '@/context'
import { Button } from '@/components/button'
import Icon from '@/components/Icon'
import LoadingIndicator from '@/components/LoadingIndicator'
import { usePermissionChecker } from '@/hooks/usePermissionChecker'
import { BsrsGrid, Column, commandColumnProps } from '@/components/BsrsGrid'
import moment from 'moment'
import { useLocalization } from '@/hooks/localization'
import { getStore } from '@/store'
import { dialogTypes } from '@/dialogs'
import { actionCreators as dialogActions } from '@/store/Dialogs'

function QlikDimensionDetail (props) {
  const id = props.match.params.id
  const [item, setItem] = useState(null)
  const [lastReloadedAt, setLastReloadedAt] = useState(moment())

  const isGranted = usePermissionChecker()
  const { localize } = useLocalization()

  const canEdit = isGranted('CanManageQlikDimensions')

  useEffect(() => {
    context.api.qlikDimensionsService.getDimension(id)
      .then(r => setItem(r))
      .catch()
  }, [id])

  const dataSourceRequest = useCallback(request => context.api.qlikDimensionsService
    .getDimensionItemsList(request, id, true), [id])

  const openEditDialog = useCallback((apiCall, item) => getStore().dispatch(dialogActions.openDialog({
    dialogType: dialogTypes.editDimensionItem,
    item: item,
    reportDimensionId: id,
    onAction: newItem => apiCall(newItem).then(setTimeout(() => setLastReloadedAt(moment()), 500))
  })), [id])

  const onAddClick = useCallback(() => openEditDialog(context.api.qlikDimensionsService.createDimensionItem, { isActive: true }),
    [openEditDialog])
  const onDelete = useCallback(x =>
    context.api.qlikDimensionsService.deleteDimensionItem(x.id).then(() => setLastReloadedAt(moment())), [])

  return !item
    ? <LoadingIndicator />
    : <Main>
      <MainTop>
        <MainTopTitle backUrl={'/dimensions-qlik'}><Resx name='Common.QlikDimensionPageTitle' /></MainTopTitle>
        {canEdit && <MainTopLeft>
          <Button color='primary' className='btn btn-md' onClick={onAddClick}>
            <Icon name='plus' />
            <Resx name={'Common.Add'} />
          </Button>
        </MainTopLeft>}
      </MainTop>
      <MainBody>
        <WhiteBox header='Reporting.General'>
          <Row>
            <Col sm='6'>
              <InfoRow>
                <InfoLabel><Resx name='Common.Name' /></InfoLabel>
                <InfoContent>{item.name}</InfoContent>
              </InfoRow>
            </Col>
            <Col sm='6'>
              <InfoRow>
                <InfoLabel><Resx name='Common.LatinName' /></InfoLabel>
                <InfoContent>{item.latinName}</InfoContent>
              </InfoRow>
            </Col>
          </Row>
          <Row>
            <Col sm='6'>
              <InfoRow>
                <InfoLabel><Resx name='Common.Code' /></InfoLabel>
                <InfoContent>{item.code}</InfoContent>
              </InfoRow>
            </Col>
            <Col sm='6'>
              <InfoRow>
                <InfoLabel><Resx name='Common.IsActive' /></InfoLabel>
                <InfoContent>{item.isActive}</InfoContent>
              </InfoRow>
            </Col>
          </Row>
        </WhiteBox>
        <WhiteBox header='Common.QlikDimensionItems'>
          <BsrsGrid lastReloadedAt={lastReloadedAt} defaultSort={[{ field: 'id', dir: 'asc' }]} dataSource={dataSourceRequest}>
            <Column field='id' title={localize('Common.Id')} editable={false} />
            <Column field='name' title={localize('Common.Name')} editable={false} />
            <Column field='latinName' title={localize('Common.LatinName')} editable={false} />
            <Column field='code' title={localize('Common.Code')} editable={false} />
            <Column field='isActive' title={localize('Common.IsActive')} editable={false} />
            <Column {...commandColumnProps({
              deleteAction: onDelete,
              deleteDisabled: x => !canEdit,
              additionalButtons: x => [{
                icon: 'pencil',
                title: localize('Common.Edit'),
                readonly: !canEdit,
                item: x,
                onClick: x => openEditDialog(context.api.qlikDimensionsService.updateDimensionItem, x)
              }]
            })} title=' ' width={150} />
          </BsrsGrid>
        </WhiteBox>
      </MainBody>
    </Main>
}

export { QlikDimensionDetail }



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/qlik-dimensions/qlik-dimension-detail.js